import { useEffect } from "react";
import useDropdownWithKeys from "./useDropdownWithKeys";

const useSuggestionDropdown = (items, searchValue, handlers) => {
  const [dropdownHandlers, isOpen, currentIndex, actions] = useDropdownWithKeys(
    items,
    handlers,
  );
  const shouldOpenSuggestions =
    items.length > 0 && (items.length > 1 || searchValue !== items[0]);

  const handleFocus = () => {
    if (shouldOpenSuggestions) {
      actions.open();
    }
  };

  const handleBlur = () => {
    actions.close();
  };

  useEffect(() => {
    if (!shouldOpenSuggestions) {
      actions.close();
    }
  }, [items, searchValue]);

  return [
    { ...dropdownHandlers, onFocus: handleFocus, onBlur: handleBlur },
    isOpen,
    currentIndex,
    actions,
  ];
};

export default useSuggestionDropdown;
